var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.summary)?_c('sellers-campaigns-summary',{attrs:{"data":_vm.data}}):_c('sellers-campaigns-details',{attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }